import { render, staticRenderFns } from "./InspectionCriteria1a.vue?vue&type=template&id=2bf25d32&scoped=true"
import script from "./InspectionCriteria1a.vue?vue&type=script&lang=ts"
export * from "./InspectionCriteria1a.vue?vue&type=script&lang=ts"
import style0 from "./InspectionCriteria1a.vue?vue&type=style&index=0&id=2bf25d32&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf25d32",
  null
  
)

export default component.exports